import { render } from "./allergensListComponent.vue?vue&type=template&id=e2b9fd2e"
import script from "./allergensListComponent.vue?vue&type=script&lang=js"
export * from "./allergensListComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\fronted-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__